import { APP_BADGE, APP_BADGE_DISABLED, APP_STAGE } from "@config-global";
import styled from "@emotion/styled";

const BADGE_SIZE = 60;

export function AppStageBadge() {
  return <>{!APP_BADGE_DISABLED && <StyledDiv stage={APP_STAGE}>{APP_BADGE || ""}</StyledDiv>}</>;
}

const StyledDiv = styled("div")<{ stage: string }>(({ stage }) => ({
  position: "fixed",
  top: BADGE_SIZE / -2,
  left: BADGE_SIZE / -2,
  zIndex: 3000,
  overflow: "hidden",
  width: BADGE_SIZE,
  height: BADGE_SIZE,
  background: "#000000",
  color: "#FFFFFF",
  boxShadow: "0 0 0.3rem rgba(0, 0, 0, 0.45)",
  fontWeight: "bold",
  fontSize: 9,
  letterSpacing: String(stage).length > 5 ? -0.5 : -0.2,
  fontFamily: "tahoma",
  lineHeight: `${BADGE_SIZE * (String(stage).length > 5 ? 1.8 : 1.72)}px`,
  textAlign: "center",
  userSelect: "none",
  transform: "rotate(-45deg)",
  ...(stage === "local" && { background: "#063AA1" }),
  ...(stage === "develop" && { background: "#18BC4D" }),
  ...(stage === "staging" && { background: "#ED214B" }),
  ...(stage === "demo" && { background: "#e95f20" }),
}));
